var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flash Dead \"All transactions\" (Homepage)",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 3233,
    transform: "translate(-666 -980)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002949"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -515,
    y: -35,
    width: 1619,
    height: 84,
    rx: 16,
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002948"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 3H3C2.17157 3 1.5 3.67157 1.5 4.5V13.5C1.5 14.3284 2.17157 15 3 15H13C13.8284 15 14.5 14.3284 14.5 13.5V4.5C14.5 3.67157 13.8284 3 13 3Z",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.25 8.5C9.66421 8.5 10 8.16421 10 7.75C10 7.33579 9.66421 7 9.25 7C8.83579 7 8.5 7.33579 8.5 7.75C8.5 8.16421 8.83579 8.5 9.25 8.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.75 8.5C12.1642 8.5 12.5 8.16421 12.5 7.75C12.5 7.33579 12.1642 7 11.75 7C11.3358 7 11 7.33579 11 7.75C11 8.16421 11.3358 8.5 11.75 8.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.25 11C9.66421 11 10 10.6642 10 10.25C10 9.83579 9.66421 9.5 9.25 9.5C8.83579 9.5 8.5 9.83579 8.5 10.25C8.5 10.6642 8.83579 11 9.25 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.75 11C12.1642 11 12.5 10.6642 12.5 10.25C12.5 9.83579 12.1642 9.5 11.75 9.5C11.3358 9.5 11 9.83579 11 10.25C11 10.6642 11.3358 11 11.75 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.25 11C4.66421 11 5 10.6642 5 10.25C5 9.83579 4.66421 9.5 4.25 9.5C3.83579 9.5 3.5 9.83579 3.5 10.25C3.5 10.6642 3.83579 11 4.25 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.75 11C7.16421 11 7.5 10.6642 7.5 10.25C7.5 9.83579 7.16421 9.5 6.75 9.5C6.33579 9.5 6 9.83579 6 10.25C6 10.6642 6.33579 11 6.75 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M4.25 13.5C4.66421 13.5 5 13.1642 5 12.75C5 12.3358 4.66421 12 4.25 12C3.83579 12 3.5 12.3358 3.5 12.75C3.5 13.1642 3.83579 13.5 4.25 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M6.75 13.5C7.16421 13.5 7.5 13.1642 7.5 12.75C7.5 12.3358 7.16421 12 6.75 12C6.33579 12 6 12.3358 6 12.75C6 13.1642 6.33579 13.5 6.75 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M9.25 13.5C9.66421 13.5 10 13.1642 10 12.75C10 12.3358 9.66421 12 9.25 12C8.83579 12 8.5 12.3358 8.5 12.75C8.5 13.1642 8.83579 13.5 9.25 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M4 2V3M12 2V3",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M14.5 5.5H1.5",
    stroke: "white",
    strokeLinejoin: "round"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 3233,
    fill: "white",
    transform: "translate(-666 -980)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b30da39484dc3702ffa86ddbf179c489.svg";
export { ForwardRef as ReactComponent };